import { CustomSocialLinksProfile } from '../CustomSocialLinks';

export const WeChat: CustomSocialLinksProfile = {
  name: 'wechat',
  matches: [
    {
      match: (input: string) => input,
      pattern: '{PROFILE_ID}',
      type: 0
    }
  ]
};
